var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { observable, action } from 'mobx';
import { api } from 'helpers/Api';
import Acount from './Model';
var default_1 = /** @class */ (function () {
    function default_1() {
        var _this = this;
        this.loaded = false;
        this.set = function (value) {
            // console.log('set - acount: ', value)
            var acount = new Acount(value);
            _this.data = acount;
            _this.loaded = true;
            return acount;
        };
    }
    default_1.prototype.read = function () {
        return api.get('client/acount').then(this.set);
    };
    default_1.prototype.create = function (data) {
        return api.post('client/acount', data).then(this.set);
    };
    default_1.prototype.version = function () {
        return api.get('acount/status');
    };
    default_1.prototype.updateVersion = function () {
        return api.post('acount/update');
    };
    default_1.prototype.patch = function (acount) {
        return api.patch('client/acount', acount).then(this.set);
    };
    __decorate([
        observable
    ], default_1.prototype, "data", void 0);
    __decorate([
        observable
    ], default_1.prototype, "loaded", void 0);
    __decorate([
        action
    ], default_1.prototype, "set", void 0);
    return default_1;
}());
export default default_1;



//////////////////
// WEBPACK FOOTER
// ./src/modules/Acount/Store.ts
// module id = 715
// module chunks = 0